import { Box, Paper, Grid, Skeleton } from "@mui/material";

const FtdLoadedSkeleton = () => {
  return (
    <>
      {/* Header Section */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={8}>
            <Skeleton variant="text" width={250} height={30} />
            <Skeleton variant="text" width={450} />
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
            }}
          ></Grid>
        </Grid>
      </Paper>
      <Paper sx={{ marginTop: 2 }}>
        {/* Header with title and time unit selector */}
        <Grid container sx={{ padding: "16px 24px" }}>
          <Grid item xs={12} md={2}>
            <Skeleton variant="rectangular" height={30} />
          </Grid>
        </Grid>

        {/* Chart Skeleton */}
        <Box sx={{ px: 3, py: 2 }}>
          <div className="shimmer-box" />
        </Box>
      </Paper>
      {/* Unloaded Conversions Breakdown */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Skeleton variant="text" width={260} height={30} />
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={4}>
            <Skeleton variant="circular" width={100} height={100} />
            <Skeleton variant="text" width={80} />
            <Skeleton variant="text" width={100} />
          </Grid>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              {Array.from({ length: 5 }).map((_, i) => (
                <Grid item xs={8} sm={2} key={i}>
                  <Skeleton variant="rectangular" height={80} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default FtdLoadedSkeleton;
